import * as React from "react";

import classnames from "classnames";

import { Link, LinkProps } from "react-router-dom";

import { Collapse } from "react-bootstrap";

import { ResolvedFilter, SvgSprite } from "@skv/core";
import FilterGroup from "./FilterGroup";

import { timingFunctions } from "polished";

import {
  OpportunitySearchQueryState,
  OrganisationSearchQueryState,
} from "@skv/state";

const filtersMediaBreakpoint = (p) => p.theme.mdBreakpoint;

interface SearchFiltersSidebarFormProps {
  filters: ResolvedFilter[];
  // onChange: Extract<FilterGroup, "onChange">;
  onChange: JSX.LibraryManagedAttributes<FilterGroup, FilterGroup["onChange"]>;
  onReset: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  resetLinkTo: LinkProps["to"];
  searchQuery: OrganisationSearchQueryState | OpportunitySearchQueryState;
}

const SearchFiltersSidebarForm: React.FC<SearchFiltersSidebarFormProps> = ({
  filters,
  onChange,
  onReset,
  resetLinkTo,
  searchQuery,
}) => {
  const [showFilters, setShowFilters] = React.useState(false);

  const isFiltered = filters.some(
    (filter) => searchQuery[filter.name] && !!searchQuery[filter.name].length
  );

  return (
    <form className="mb-3 mr-lg-4">
      <header className="mb-2 mx-n2 d-flex align-items-center justify-content-between">
        <div className="px-2 py-3">
          <h2 className="font-weight-bold mb-0 d-none d-md-block">Filters</h2>
          <button
            css={`
              background: transparent;
            `}
            type="button"
            aria-label="Filter list toggler"
            aria-expanded={showFilters ? "true" : "false"}
            className={classnames(
              "font-weight-bold small mb-0 p-0 border-0 d-md-none",
              showFilters && "active"
            )}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters
            <SvgSprite
              id="icons:chev-down"
              width={12}
              height={12}
              css={`
                margin-left: 0.5rem;

                transition: transform 0.3s ${timingFunctions("easeOutCubic")};

                .active & {
                  transform: rotate3d(1, 0, 0, 180deg);
                }
              `}
            />
          </button>
        </div>

        {isFiltered && (
          <div className="px-2">
            <Link
              to={resetLinkTo}
              onClick={onReset}
              className="text-danger small"
            >
              Reset
            </Link>
          </div>
        )}
      </header>
      <Collapse in={showFilters}>
        <div
          css={`
            @media (min-width: ${filtersMediaBreakpoint}) {
              &.collapse:not(.show) {
                display: block;
              }
            }
          `}
        >
          {filters.map((f, idx) => {
            return (
              <FilterGroup
                key={idx}
                searchQuery={searchQuery}
                heading={f.label}
                name={f.name}
                data={f.data}
                onChange={onChange}
              />
            );
          })}
        </div>
      </Collapse>
    </form>
  );
};

export default SearchFiltersSidebarForm;
